import init from "./src/init";
window.addEventListener('DOMContentLoaded', init);